import { Step } from '@atoms/step';
import { Fragment } from 'react';

const Divider = () => {
  return (
    <div className="border-ui-border mx-2 mt-3 w-full border-t md:mx-5 lg:mx-6 xl:mx-6"></div>
  );
};

export type StepProps = {
  label: string;
  urlPaths: string[];
};

export type StepperProps = {
  pathname: string;
  steps: StepProps[];
};

function getStepProgress(pathname: string, steps: StepProps[]) {
  const status: { [key: string]: string } = {};
  steps.forEach((_, index) => {
    status[`step${index + 1}`] = `${index + 1}`;
  });

  let foundIndex = -1;

  for (let i = 0; i < steps.length; i++) {
    if (steps[i].urlPaths.includes(pathname)) {
      foundIndex = i;
      break;
    }
  }

  if (foundIndex > 0) {
    for (let i = 0; i < foundIndex; i++) {
      status[`step${i + 1}`] = '✔';
    }
  }
  return status;
}

export const Stepper = (props: StepperProps) => {
  const currentStepStyle = 'bg-brand-primary font-semibold !text-white';
  const { pathname, steps } = props;
  const stepProgress = getStepProgress(pathname, steps);
  return (
    <div
      aria-label="Stepper"
      className="mx-6 mb-1 mt-12 flex justify-between pb-10"
    >
      {steps.map((step, i) => (
        <Fragment key={step.label}>
          {i > 0 ? <Divider /> : null}
          <Step
            label={step.label}
            progress={stepProgress[`step${i + 1}`]}
            className={`${step.urlPaths.includes(pathname) ? currentStepStyle : ''}`}
          />
        </Fragment>
      ))}
    </div>
  );
};
